module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/title-custom-apparel-8cf394d33cfb9a6ec785e9ed68e400d7.svg";